import React, {
    useEffect, 
    useRef, 
    useState, 
    useCallback, 
    // useMemo
} from 'react'
import PropTypes from 'prop-types'
// import {noUiSlider} from 'nouislider'
import * as noUiSlider from 'nouislider';


import TextField from './../../Atoms/TextField'

// import 'nouislider/distribute/nouislider.css'
import 'nouislider/dist/nouislider.css';


const RangeSliderComponent = (props) => {
    const { 
        min,
        max,
        onChange,
        clearSlider
    } = props

    
    useEffect(()=> {
        if(refHtml5Slider?.current?.noUiSlider){
            console.log('squellhola')
            refHtml5Slider.current.noUiSlider.reset()
        }
    }, [clearSlider])

    const [values, setValues] = useState( {})


    const refContainer = useRef(null)
    const refHtml5Slider = useRef(null)
    const refInputMinNumber = useRef(null)
    const refInputMaxNumber = useRef(null)

    const setMinValue = useCallback((value) =>{
        setValues(s => ({ ...s, minPrice: Math.round(value)}))
    }, [])

    const setMaxValue = useCallback((value) =>{
        setValues(s => ({ ...s, maxPrice:  Math.round(value)}))
    },[])

    useEffect(()=>{
        
        var inputMinNumber = refInputMinNumber.current
        // Append the option elements
        // for (var i = min; i <= max; i++) {

        //     var option = document.createElement("option")
        //     option.text = i
        //     option.value = i

        //     inputMinNumber.appendChild(option)
        // }
        
        var html5Slider = refHtml5Slider.current
        noUiSlider.create(html5Slider, {
            start: [min, max],
            connect: true,
            range: {
                'min': min,
                // '30%': [(max / 10), ((max / 10) / 10)],
                // '50%': [ max / 2, (max + min) / 100],
                'max': max,
            }
        })

        var inputMaxNumber = refInputMaxNumber.current
        html5Slider.noUiSlider.on('update', function (values, handle) {

            var value = values[handle];

            if (handle) {
                inputMaxNumber.value =  Math.round(value);
                // setValues(s => ({ ...s, maxPrice:  Math.round(value)}))
                setMaxValue(value)

               

            } else {
                inputMinNumber.value = Math.round(value);
                // setValues(s => ({ ...s, minPrice: Math.round(value)}))
                setMinValue(value)
                
            }
        })

        inputMinNumber.addEventListener('change', function () {
            html5Slider.noUiSlider.set([this.value, null])
        })

        inputMaxNumber.addEventListener('change', function () {
            html5Slider.noUiSlider.set([null, this.value])
        })
        // setValues(html5Slider.noUiSlider.get())
    },[min, max,setMinValue, setMaxValue])

    useEffect(()=>{
        onChange(values)
        console.log("onchange.....",values)
        // eslint-disable-next-line
    }, [values]) //no colocar onChange como dependecia por que activa muchos watch si se estan usando

    return(
        <div 
            ref={refContainer}
            className="rangeSliderCom"
        >
            <div className='rangeSliderComSlider' ref={refHtml5Slider}></div>

            <div className='rangeSliderComInputs'>
                <span className='textDescribe'>De</span>
                <TextField
                    placeholder={`$${min}.00`}
                    ref={refInputMinNumber} 
                    name='rangeMin'
                    id='rangeMin'
                    type='number'
                    // step={100}
                    className="rangeSlider-InputSelect"
                />

                <span className='textDescribe rangeA'>A</span>
                <TextField
                    placeholder={`$${max}.00`}
                    ref={refInputMaxNumber} 
                    name='rangeMax'
                    id='rangeMax'
                    type='number'
                    // step={100}
                    className="rangeSlider-InputNumber"
                />

            </div>

            {/* {JSON.stringify(values)} */}
        </div>
    )
}

RangeSliderComponent.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    onChange: PropTypes.func,
    clearSlider: PropTypes.bool
}
RangeSliderComponent.defaultProps = {
    min: 0,
    max: 100,
    onChange: ()=>{},
    clearSlider: false
}

export default React.memo(RangeSliderComponent)